import React from 'react';

import cn from '~/Utils/cn';

import AgentTimelineEntryDisplay from './AgentTimelineEntryDisplay';
import type { AgentTimelineProps } from './types';

const AgentTimeline: React.FC<AgentTimelineProps> = ({ entries, isDefaultExpanded = true, className }) => {
  if (entries.length === 0) {
    return null;
  }

  return (
    <div className={cn('agent-timeline relative w-full', className)}>
      {entries.map((entry, index) => (
        <AgentTimelineEntryDisplay
          key={entry.id}
          entry={entry}
          isLast={index === entries.length - 1}
          defaultExpanded={entry.content ? isDefaultExpanded : false}
        />
      ))}
    </div>
  );
};

export default AgentTimeline;
